import LayoutBuyingGuide from 'components/Content/ContentLayout/LayoutBuyingGuide/LayoutBuyingGuide';

export default LayoutBuyingGuide;
